<!--
 * @Author: your name
 * @Date: 2021-07-05 15:42:09
 * @LastEditTime: 2021-07-16 18:46:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\allCategoriesUnit.vue
-->
<template>
  <div class="allCategories" :class="{'content-border':showBorder}">
      <p>全部分类 <i class="el-icon-arrow-down"></i></p>
  </div>
</template>

<script>
export default {
  props:{
        activeName: {
            type: String,
            default: ''
        },
        // channelList
  },
  computed: {
        showBorder(){
            return  this.activeName=='allCategories'?true:false
        }
  },
  methods:{
    test(){
      
    }
  }
  
}
</script>

<style lang='scss' scoped>
@import '../../../../assets/css/theme.scss';
.allCategories{
    width: 220px;
    height: 40px;
    line-height: 40px;
    background:$main-col;
    color:#fff;
    font-size:14px;
    text-align: center;
    cursor: pointer;
    position: relative;
    z-index: 10;
    i{
      padding-left:20px;
    }


}
.content-border:after{
    content: "";
    position: absolute;
    left: 0px;
    bottom:0;
    top:0;
    right:0;
    border:2px dashed red;  
    z-index: 50;
}


</style>
